"use strict";
// Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
var DefaultDOMWebSocket = /** @class */ (function () {
    function DefaultDOMWebSocket(webSocket) {
        this.webSocket = webSocket;
    }
    Object.defineProperty(DefaultDOMWebSocket.prototype, "url", {
        get: function () {
            return this.webSocket.url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DefaultDOMWebSocket.prototype, "onopen", {
        get: function () {
            return this.webSocket.onopen;
        },
        set: function (listener) {
            this.webSocket.onopen = listener;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DefaultDOMWebSocket.prototype, "onerror", {
        get: function () {
            return this.webSocket.onerror;
        },
        set: function (listener) {
            this.webSocket.onerror = listener;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DefaultDOMWebSocket.prototype, "onclose", {
        get: function () {
            return this.webSocket.onclose;
        },
        set: function (listener) {
            this.webSocket.onclose = listener;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DefaultDOMWebSocket.prototype, "onmessage", {
        get: function () {
            return this.webSocket.onmessage;
        },
        set: function (listener) {
            this.webSocket.onmessage = listener;
        },
        enumerable: false,
        configurable: true
    });
    DefaultDOMWebSocket.prototype.addEventListener = function (type, listener, options) {
        this.webSocket.addEventListener(type, listener, options);
    };
    DefaultDOMWebSocket.prototype.removeEventListener = function (type, listener, options) {
        this.webSocket.removeEventListener(type, listener, options);
    };
    DefaultDOMWebSocket.prototype.dispatchEvent = function (event) {
        return this.webSocket.dispatchEvent(event);
    };
    DefaultDOMWebSocket.prototype.send = function (data) {
        this.webSocket.send(data);
    };
    DefaultDOMWebSocket.prototype.close = function (code, reason) {
        this.webSocket.close(code, reason);
    };
    return DefaultDOMWebSocket;
}());
exports.default = DefaultDOMWebSocket;
//# sourceMappingURL=DefaultDOMWebSocket.js.map